import api from "./api";

export const leadService = {
  getAll: (filters = {}) => api.get("/leads", { params: filters }).then((res) => res.data),
  getById: (id) => api.get(`/leads/${id}`).then((res) => res.data),
  create: (data) => api.post("/leads", data).then((res) => res.data),
  update: (id, data) => api.put(`/leads/${id}`, data).then((res) => res.data),
  delete: (id) => api.delete(`/leads/${id}`).then((res) => res.data),
};
